import PersonalApiKeysTableCreatedAtCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/CreatedAtCell";
import PersonalApiKeysTableExpiresAtCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/ExpiresAtCell";
import PersonalApiKeysTableIssuesCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/IssuesCell";
import PersonalApiKeysTableKeyIdCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/KeyIdCell";
import PersonalApiKeysTableLastUsedCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/LastUsedCell";
import PersonalApiKeysTableNameCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/NameCell";

import { USER_PERSONAL_API_KEYS_COLUMN_ID } from "../constants";
import UserPersonalApiKeysTableActionsCell from "./ActionsCell";

export const USER_PERSONAL_API_KEYS_TABLE_CELLS = {
  [USER_PERSONAL_API_KEYS_COLUMN_ID.NAME]: PersonalApiKeysTableNameCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.ISSUES]: PersonalApiKeysTableIssuesCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.KEY_ID]: PersonalApiKeysTableKeyIdCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.CREATED_AT]: PersonalApiKeysTableCreatedAtCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.EXPIRES_AT]: PersonalApiKeysTableExpiresAtCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.LAST_USED]: PersonalApiKeysTableLastUsedCell,
  [USER_PERSONAL_API_KEYS_COLUMN_ID.ACTIONS]: UserPersonalApiKeysTableActionsCell,
};
